import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ReviewsFullBlock } from "../components/ReviewsFullBlock";

type IProps = Immutable<templates.ReviewsFullBlockTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <ReviewsFullBlock value={props.value} />;
};
